import { Component, OnInit } from '@angular/core';
import { DataMasterService } from 'src/app/services/data-master.service';

@Component({
  selector: 'app-admin-access',
  templateUrl: './admin-access.component.html',
  styleUrls: ['./admin-access.component.scss']
})
export class AdminAccessComponent implements OnInit {

  constructor(public dataService : DataMasterService ) {
  }

  ngOnInit(): void {
  }

}
